import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { facturaPosPath, type FacturaPosLocationState } from '../../config/routes';

const parsePositiveInt = (value: string | null): number | undefined => {
  if (!value) return undefined;
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

const FacturaVentaAltaRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navState = location.state as FacturaPosLocationState | null;

  const target = facturaPosPath({
    pedidoId: parsePositiveInt(searchParams.get('pedidoId')),
    cotizacionId: parsePositiveInt(searchParams.get('cotizacionId')),
    facturaId: parsePositiveInt(searchParams.get('facturaId')),
  });

  return (
    <Navigate
      replace
      to={target}
      state={navState?.ventaPendiente ? { ventaPendiente: navState.ventaPendiente } : undefined}
    />
  );
};

export default FacturaVentaAltaRedirect;
